import {inject, Injectable} from '@angular/core';
import {TenantService} from './tenant.service';
import {TrackJS} from 'trackjs';
import {environment} from '../../environments/environment';
import {select, Store} from '@ngrx/store';
import {AppState} from '../store';
import {selectUser} from '../store/selectors';
import {ANONYMOUS_USER} from '../models/user.model';

export enum ErrorGroups {
  AUTH_ERRORS = 'Authentication Errors',
  NETWORK_ERRORS = 'Network Issues',
  API_ERRORS = 'API Call Failures',
  INSUFFICIENT_PERMISSIONS = 'Insufficient Permissions',
  GENERAL_ERRORS = 'General Errors'
}

export const errorTypes = {
  authErrors: [
    'auth/user-not-found',
    'auth/wrong-password',
    'auth/email-already-in-use',
    'auth/popup-blocked',
    'auth/popup-closed-by-user',
    'auth/network-request-failed'
  ],
  networkErrors: [
    'network-request-failed',
    'Network Error',
    'NetworkError',
    'Network',
    'Failed to fetch',
    'Request Timeout'
  ],
  apiErrors: [
    'api'
  ],
  insufficientPermissions: [
    'Missing or insufficient permissions'
  ]
}


@Injectable({
  providedIn: 'root'
})
export class TrackJsService {

  tenantService = inject(TenantService);

  store = inject(Store<AppState>);



constructor() {

  console.log('### TrackJsService constructor');
    if (environment?.trackJS) {

      TrackJS.install(environment.trackJS);

      // set the tenant Id
      TrackJS.addMetadata('tenantId', this.tenantService.id);

      // set the user Id if the user is logged in
      this.store.pipe(
        select(selectUser)
      ).subscribe(user => {
          if (user?.id !== ANONYMOUS_USER.id) {
            TrackJS.configure({
              userId: user.id
            });
          }
        });
    }
  }


  logError(error: any, actualError?: any): void {
    error = `${error},  ${actualError}`;
    if (typeof error === 'string' && error.includes('Upload cancelled by user')) {
      console.log('User cancelled upload, not logging to TrackJS');
      return;
    }

    if (typeof TrackJS !== 'undefined') {

      console.log('Logging error to TrackJS', error);

      categorizeError(error);

      TrackJS.track(error);
    }
    else {
      console.error('TrackJS is not defined, not tracking error.');
    }
  }
}

export function categorizeError(error: any): void {

  let errorCategory = ErrorGroups.GENERAL_ERRORS;

  if (typeof error === 'string') {

    if (errorTypes.apiErrors.some(apiError => error.includes(apiError))) {

      errorCategory = ErrorGroups.API_ERRORS;

    } else if (errorTypes.authErrors.some(authError => authError.includes(error) || error.includes(authError))) {

      errorCategory = ErrorGroups.AUTH_ERRORS;

    } else if (errorTypes.networkErrors.some(networkError => networkError.includes(error) || error.includes(networkError))) {

      errorCategory = ErrorGroups.NETWORK_ERRORS;

    } else if (errorTypes.insufficientPermissions.some(permissionError => permissionError.includes(error) || error.includes(permissionError))) {

      errorCategory = ErrorGroups.INSUFFICIENT_PERMISSIONS;
    }
  }

  TrackJS.addMetadata('errorGroup', errorCategory);
}
